module.exports = __webpack_public_path__ + "img/location.e1b2de6f.svg";